import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    //id: IdRef, optional // Mã người dùng
    ho_ten: { //required // Tên người dùng
        ten: null, //string, optional // Tên
        ho: null, //string, optional // Họ
        ho_ten: null, //string, required // Họ tên đầy đủ
        dinh_dang: null, //string, optional, enum(hoten, tenho) // Định dạng tên
    },
    email: null, //string, optional // Email
    dien_thoai: null, //string, optional // Số điện thoại
    gioi_tinh: null, //integer, optional, min: 1, max: 4 // Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
    ngay_sinh: { //object, optional // Ngày tháng năm sinh
        ngay: null, //integer, optional, min: 1, max: 31 // Ngày
        thang: null, //integer, optional, min: 1, max: 12 // Tháng
        nam: null, //integer, optional // Năm
        ngay_sinh: null, // datetime, optional // Ngày sinh
    },
    giay_to: [], //array of object, optional // Giấy tờ, ví dụ: CMT, CCCD, Họ chiếu

    quoc_tich: { //object, optional // Quốc tịch
        quoc_tich_id: null, //IdRef, optional // Mã quốc tịch
        ten_quoc_tich: null, //string, optional // Tên quốc tịch
    },
    dia_chi: { //object, optional // Địa chỉ
        province_id: null, //IdRef, optional // Mã tỉnh/TP
        province_name: null, //string, optional // Tên tỉnh/TP
        district_id: null, //IdRef, optional // Mã quận/huyện
        district_name: null, //string, optional // Tên quận/huyện
        dia_chi: null, //string, required // Địa chỉ đầy đủ
    },
    avatar_id: null, //IdRef, optional // Mã ảnh đại diện
    the_hdv: { //object, required // Thẻ hướng dẫn viên du lịch
        so_the: null, //string, required // Số thẻ Hướng dẫn viên
        loai_the: null, //string, optional, enum(quoc_te, noi_dia, tai_diem) // Loại thẻ
        ngay_cap: null, //datetime, optional // Ngày cấp
        noi_cap: null, //string, optional // Nơi cấp
        het_han: null, //datetime, optional // Ngày hết hạn
    },
    ngoai_ngu: [], //array of IdRef, optional // Danh sách ngôn ngữ
    so_truong: [], //array of IdRef, optional // Danh sách sở trường
    thanh_tich: null, //string, optional // Thành tích
    lich_su_hanh_nghe: null, //string, optional // Lịch sử hành nghề
};

// validation form
model.validForm = {
    ho_ten: { //required // Tên người dùng
        ten: [], //string, optional // Tên
        ho: [], //string, optional // Họ
        ho_ten: [], //string, required // Họ tên đầy đủ
        dinh_dang: [], //string, optional, enum(hoten, tenho) // Định dạng tên
    },
    email: [], //string, optional // Email
    dien_thoai: [], //string, optional // Số điện thoại
    gioi_tinh: [], //integer, optional, min: 1, max: 4 // Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
    ngay_sinh: { //object, optional // Ngày tháng năm sinh
        ngay: [], //integer, optional, min: 1, max: 31 // Ngày
        thang: [], //integer, optional, min: 1, max: 12 // Tháng
        nam: [], //integer, optional // Năm
    },
    giay_to: [], //array of object, optional // Giấy tờ, ví dụ: CMT, CCCD, Họ chiếu

    quoc_tich: { //object, optional // Quốc tịch
        quoc_tich_id: [], //IdRef, optional // Mã quốc tịch
        ten_quoc_tich: [], //string, optional // Tên quốc tịch
    },
    dia_chi: { //object, optional // Địa chỉ
        province_id: [], //IdRef, optional // Mã tỉnh/TP
        province_name: [], //string, optional // Tên tỉnh/TP
        district_id: [], //IdRef, optional // Mã quận/huyện
        district_name: [], //string, optional // Tên quận/huyện
        dia_chi: [], //string, required // Địa chỉ đầy đủ
    },
    avatar_id: [], //IdRef, optional // Mã ảnh đại diện
    the_hdv: { //object, required // Thẻ hướng dẫn viên du lịch
        so_the: [], //string, required // Số thẻ Hướng dẫn viên
        loai_the: [], //string, optional, enum(quoc_te, noi_dia, tai_diem) // Loại thẻ
        ngay_cap: [], //datetime, optional // Ngày cấp
        noi_cap: [], //string, optional // Nơi cấp
        het_han: [], //datetime, optional // Ngày hết hạn
    },
    ngoai_ngu: [], //array of IdRef, optional // Danh sách ngôn ngữ
    so_truong: [], //array of IdRef, optional // Danh sách sở trường
    thanh_tich: [], //string, optional // Thành tích
    lich_su_hanh_nghe: [], //string, optional // Lịch sử hành nghề
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    giay_to: {
        loai_giay_to: null, //string, required, enum(CMT, CCCD, PASSPORT) // Loại giấy tờ
        so_giay_to: null, //string, required // Số giấy tờ
        noi_cap: null, //string, optional // Nơi cấp
        ngay_cap: null, //datetime, optional // Ngày cấp
        ngay_het_han: null, //datetime, optional // Ngày hết hạn
    }
};

// validation các form khác
model.validFormOther = {
    giay_to: {
        loai_giay_to: [], //string, required, enum(CMT, CCCD, PASSPORT) // Loại giấy tờ
        so_giay_to: [], //string, required // Số giấy tờ
        noi_cap: [], //string, optional // Nơi cấp
        ngay_cap: [], //datetime, optional // Ngày cấp
        ngay_het_han: [], //datetime, optional // Ngày hết hạn
    }
};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["ho_ten", "ascending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            "ho_ten.ho_ten": "",
            "email": "",
            dien_thoai: "",
            "the_hdv.so_the": ""
        },
        valid: {
            dien_thoai:[ValidService.checkNumber, ValidService.checkPhone]
        },
        operator: {
            "ho_ten.ho_ten": ":regex_i:", //:regex:, $vn_text=Viêt nam
            "email": ":regex_i:",
            "dien_thoai": ":regex_i:",
            "the_hdv.so_the": ":regex_i:"
        }
    }
};

export default model;